import { Link } from "react-router-dom";
function SchoolHall() {
  return (
    <>
      <div className="innerslide py-3 bg-light border-bottom">
        <ul className="breadcrumb container mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item"> Facilities</li>
          <li className="breadcrumb-item active">School Hall</li>
        </ul>
      </div>
      <div className="innersec container my-5">
        <div className="row g-3 facilities_section_imgs">
          <div class="col-lg-12">
            <h1> School Hall </h1>
            <p>
              A school hall serves as a central gathering space for assemblies,
              cultural programs, performances, examinations, and important
              school events, providing a versatile venue that supports community
              building, student expression, and the smooth conduct of various
              academic and extracurricular activities.
            </p>
          </div>
        </div>
        <br />

        <div className="row g-3 facilities_section_imgs">
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            {" "}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/School_hall_1.jpeg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />{" "}
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            {" "}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/School_hall_2.jpeg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />{" "}
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            {" "}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/School_hall_3.jpeg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />{" "}
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            {" "}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/School_hall_4.jpeg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />{" "}
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            {" "}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/School_hall_5.jpeg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />{" "}
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            {" "}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/School_hall_6.jpeg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />{" "}
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            {" "}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/School_hall_7.jpeg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />{" "}
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            {" "}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/School_hall_8.jpeg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />{" "}
          </div>
        </div>
      </div>
    </>
  );
}
export default SchoolHall;
